import React from 'react';
import cx from 'classnames';

import { locale } from '@trqk/utils';

import { ManageStatementsLink } from '../../../../../nav';
import { TourCard } from '../../TourCard';

import iconUrl from '../../../../../../assets/svg/insights-empty-statement.svg';
import grayIconUrl from '../../../../../../assets/svg/insights-empty-statement-grayscale.svg';

const body = <div>{locale.enUS.INSIGHTS.CARDS.STEP_1_ADD_STATEMENTS.BODY}</div>;

/**
 * Displays the Add Statements step of the Insights cards tour.
 */
export const AddStatements = ({
    checked,
    step,
}: TourCardInstanceProps): JSX.Element => {
    const footer = (
        <ManageStatementsLink
            className={cx('font-semibold underline', {
                'text-primary-500': !checked,
                'text-tertiary-400': checked,
            })}
        >
            {locale.enUS.INSIGHTS.CARDS.STEP_1_ADD_STATEMENTS.FOOTER}
        </ManageStatementsLink>
    );

    return (
        <TourCard
            body={body}
            checked={checked}
            footer={footer}
            grayIconUrl={grayIconUrl}
            iconUrl={iconUrl}
            iconWidth={120}
            step={step}
            title={locale.enUS.INSIGHTS.CARDS.STEP_1_ADD_STATEMENTS.TITLE}
        />
    );
};
